import { render } from "./Wrapper.vue?vue&type=template&id=0cd43513"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=0cd43513&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0cd43513"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cd43513', script)) {
    api.reload('0cd43513', script)
  }
  
  module.hot.accept("./Wrapper.vue?vue&type=template&id=0cd43513", () => {
    api.rerender('0cd43513', render)
  })

}

script.__file = "src/components/Wrapper.vue"

export default script